import { t } from '@transifex/native';
import { Dialog, DialogTrigger } from '~/components/ui/dialog';
import { cn } from '~/lib/utils';
import { GamificationDailyLoginStatusModal } from '~/components/ui/gamification/gamification-daily-login-status-modal';

export type GamificationLoginStatProps = {
  value: number;
  maxValue: number;
  weeklyLoginWeekdays: number[];
  bonusXp: number;
  className?: string;
};

export function GamificationLoginStat({
  value,
  maxValue,
  weeklyLoginWeekdays,
  bonusXp,
  className,
}: GamificationLoginStatProps) {
  const displayValue = `${Math.max(0, Math.min(value, maxValue))}/${maxValue}`;
  const goalMet = value >= maxValue;

  return (
    <Dialog>
      <DialogTrigger
        className={cn(
          `
            inline-flex h-8 cursor-pointer items-center justify-center gap-xs
            overflow-hidden rounded-full border-0 px-xs text-body-small
            transition-colors
            hover:bg-primary-200 hover:shadow-xs
            focus-visible:ring-2 focus-visible:ring-ring
            focus-visible:ring-offset-2 focus-visible:outline-none
          `,
          className
        )}
        aria-label={t('Daily login status: {value}', { value: displayValue })}
      >
        <img
          src="/assets/gamification/daily-login.svg"
          alt=""
          className="size-5 shrink-0 object-contain"
          aria-hidden
        />
        <span className="text-text-900">{displayValue}</span>
      </DialogTrigger>
      <GamificationDailyLoginStatusModal
        weeklyLoginDays={value}
        requiredLoginDays={maxValue}
        bonusXp={bonusXp}
        weeklyLoginWeekdays={weeklyLoginWeekdays}
        goalMet={goalMet}
      />
    </Dialog>
  );
}
